import { useQuery } from '@tanstack/react-query';
import type { CoinMode } from '@ui/hooks/useCoinMode';
import { useCoinMode } from '@ui/hooks/useCoinMode';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import { getStakeTransactionFee } from '@ui/queries/sdk';
import { currentWallet } from '@veno-app/wallet';

const { useAccount } = currentWallet;

const useStakeTransactionFee = (_coinMode?: CoinMode) => {
  const account = useAccount();
  const sdk = useVenoSDK();
  const globalCoinMode = useCoinMode();
  const coinMode = _coinMode ?? globalCoinMode;
  const stakeFeeQuery = getStakeTransactionFee(sdk, account ?? '', coinMode);
  const { data: stakeFee } = useQuery(
    stakeFeeQuery.queryKey,
    stakeFeeQuery.queryFn,
    {
      enabled: !!account,
    },
  );

  return stakeFee;
};

export default useStakeTransactionFee;
